import React from 'react';
import propTypes from 'prop-types';

const MessageParser = ({ children, actions }) => {
    const parse = (message) => {
        if (children.props.state.widget === 'emailGPT') {
            actions.handleEmailGeneration(message);
        } else if (message?.includes('yes')) {
            actions.handleYes(message);
        } else if (message?.includes('no')) {
            actions.handleNo(message);
        } else {
            actions.handleSupportGeneration(message);
        }
    };

    return (
        <div>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    parse: parse,
                    actions,
                });
            })}
        </div>
    );
};

MessageParser.propTypes = {
    actions: propTypes.shape({
        handleEmailGeneration: propTypes.func,
        handleSupportGeneration: propTypes.func,
        handleDefaultResponse: propTypes.func,
        handleYes: propTypes.func,
        handleNo: propTypes.func,
        handleIntro: propTypes.func,
    }),
    children: propTypes.node,
};
export default MessageParser;
